// extracted by mini-css-extract-plugin
export default {"inputContainer":"PresetDialog-module__inputContainer--bQiQj","textInput":"PresetDialog-module__textInput--BLPGV"};